import * as React from 'react';
import TextField from '@mui/material/TextField';
import { useCommonStyles } from '../common';
import { useField } from 'formik';

const InputField = (props: any) => {
	const [field, meta] = useField(props);
	const classes: any = useCommonStyles(props);
	const errorText = meta.error && meta.touched ? meta.error : '';
	return (
		<TextField
			{...props}
			{...field}
			style={{ display: 'flex' }}
			helperText={errorText}
			error={!!errorText}
			InputProps={{
				classes: {
					root: classes.textColor,
				},
				...props.InputProps,
			}}
		/>
	);
};

export default InputField;
